var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "moving-arrow", style: _vm.arrowStyle })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }